import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

export const drugListSelector = createSelector(
  (state: RootState) => state.drug.drugList,
  (drugList) => drugList,
);

export const isEnableLoadingSelector = createSelector(
  (state: RootState) => state.drug,
  (item) => item.nextToken !== '',
);

export const isInitDrugSelector = createSelector(
  (state: RootState) => state.drug,
  (item) => item.nextToken !== null,
);
